'use strict';

angular.module('imagetrend.components')
    .directive('hlpSlushbox', ['$rootScope', '$templateCache', '$timeout', function ($rootScope, $templateCache, $timeout) {
        var directiveScope = angular.extend({}, $rootScope.formFieldScope, {
            ngModel: '=?',
            question: '=?',
            showValue: '=?',
            onChange: '&?',
            options: '=?',
            parameters: '=?'
        });
        return {
            scope: directiveScope,
            require: 'ngModel',
            transclude: true,
            template: function () {
                return $templateCache.get('templates/slush-box/slush-box.html');
            },
            controller: ['$filter', '$scope', '$timeout', function ($filter, $scope, $timeout) {
                $scope.add = function (added) {
                    if ($scope.ngModel == null) {
                        $scope.ngModel = [];
                    }

                    if (added != null) {
                        added.forEach(function (add) {
                            add.sort_order = $scope.ngModel.length + 1;
                            if ($scope.compareValue != $scope.arrayValue) {
                                add[$scope.compareValue] = add[$scope.arrayValue];
                            }
                            if ($scope.availableShow != $scope.selectShow) {
                                add[$scope.selectShow] = add[$scope.availableShow];
                            }
                            $scope.ngModel.push(add);
                        })
                    }

                    $scope.ngChange();
                }

                $scope.addAll = function () {
                    if ($scope.ngModel == null) {
                        $scope.ngModel = [];
                    }

                    $filter('filter')($scope.dirOptions, $scope.filterFn).forEach(function (add) {
                        add.sort_order = $scope.ngModel.length + 1;
                        if ($scope.compareValue != $scope.arrayValue) {
                            add[$scope.compareValue] = add[$scope.arrayValue];
                        }
                        if ($scope.availableShow != $scope.selectShow) {
                            add[$scope.selectShow] = add[$scope.availableShow];
                        }
                        $scope.ngModel.push(add);
                    })

                    $scope.ngChange();
                }

                $scope.remove = function (removed) {
                    if ($scope.ngModel == null) {
                        $scope.ngModel = [];
                    }

                    if (removed != null) {
                        removed.forEach(function (remove) {
                            removeByAttr($scope.ngModel, $scope.compareValue, remove[$scope.compareValue]);
                        })
                    }

                    $scope.ngModel.sort(sortObjectArray('sort_order')).forEach(function (item, index) {
                        item.sort_order = index + 1;
                    })

                    $scope.ngChange();
                }

                $scope.removeAll = function () {
                    $scope.ngModel = [];
                    $scope.ngChange();
                }

                $scope.up = function (up) {
                    $scope.ngModel.sort(sortObjectArray('sort_order')).forEach(function (item) {
                        up.sort(sortObjectArray('sort_order')).forEach(function (upitem) {
                            if (upitem.sort_order - item.sort_order == 1) {
                                item.sort_order++;
                                upitem.sort_order--;
                            }
                        })
                    })
                    $scope.ngModel.sort(sortObjectArray('sort_order'))
                    $scope.ngChange();
                }

                $scope.down = function (down) {
                    $scope.ngModel.sort(sortObjectArray('sort_order')).reverse().forEach(function (item) {
                        down.sort(sortObjectArray('sort_order')).forEach(function (downitem) {
                            if (item.sort_order - downitem.sort_order == 1) {
                                item.sort_order--;
                                downitem.sort_order++;
                            }
                        })
                    })
                    $scope.ngModel.sort(sortObjectArray('sort_order'))
                    $scope.ngChange();
                }

                $scope.validate = function () {
                    if ($scope.innerForm !== undefined) {
                        if ($scope.question !== undefined && $scope.question.answer !== undefined) {
                            $scope.question.answer.invalid = !isEmpty($scope.innerForm.slushbox.$error);
                        }
                    }
                }

                var validationTimeout = $timeout($scope.validate(), 0);

                $scope.$on('$destroy', function () {
                    $timeout.cancel(validationTimeout);
                });
            }],
            compile: function(elem, attrs){
                return {
                    pre: function (scope, elem, attrs, ngModel) {

                        scope.directiveAttributes = attrs;

                        if (!scope.directiveAttributes.selectShow) { scope.selectShow = 'name'; }
                        if (!scope.directiveAttributes.selectSort) { scope.selectSort = 'sort_order'; }
                        if (!scope.directiveAttributes.selectValue) { scope.selectValue = 'id'; }
                        if (!scope.directiveAttributes.availableShow) { scope.availableShow = 'name'; }
                        if (!scope.directiveAttributes.availableSort) { scope.availableSort = 'name'; }
                        if (!scope.directiveAttributes.compareValue) { scope.compareValue = 'id'; }
                        if (!scope.directiveAttributes.arrayValue) { scope.arrayValue = 'id'; }

                        scope.selectedOptionClause = "getDescendantProp(opt,selectShow) for opt in ngModel | orderBy:selectSort";
                        scope.availableOptionClause = "getDescendantProp(opt,availableShow) for opt in dirOptions | filter:filterFn | orderBy:availableSort";
                    },
                    post: function (scope, elem, attrs, ngModel) {
                        scope.timeouts = [];

                        scope.setShowValue = function () {
                            if (ngModel.$modelValue != null && angular.isArray(ngModel.$modelValue)) {
                                scope.showValue = null;
                                ngModel.$modelValue.forEach(function (opt) {
                                    if (scope.showValue == null) {
                                        scope.showValue = scope.getDescendantProp(opt, scope.selectShow);
                                    }
                                    else {
                                        scope.showValue += ', ' + scope.getDescendantProp(opt, scope.selectShow);
                                    }
                                })
                            }
                        }

                        var needToChangeToString = false;

                        scope.$watch('optionsLoaded', function (optionsLoaded) {
                            if (optionsLoaded) {
                                if (needToChangeToString && angular.isString(ngModel.$modelValue)) {
                                    var newModel = [];
                                    if (scope.dirOptions != null && angular.isArray(scope.dirOptions)) {
                                        ngModel.$modelValue.split(',').forEach(function (item, index) {
                                            scope.dirOptions.forEach(function (element) {
                                                if (element.id.toString().toLowerCase() == item.toLowerCase()) {
                                                    newModel.push(element);
                                                }
                                            })
                                        });
                                    }
                                    scope.ngModel = newModel;

                                    if (scope.showValue == null) {
                                        scope.setShowValue();
                                    }

                                    if (scope.sortable) {
                                        ngModel.$modelValue.forEach(function (item, index) {
                                            item.sort_order = index + 1;
                                        });

                                        scope.ngChange();
                                    }
                                }
                                else if (scope.showValue == null) {
                                    scope.setShowValue();
                                }
                                if (scope.isRequired && (scope.innerForm !== undefined)) {
                                    if (ngModel.$modelValue == null || ngModel.$modelValue.length == 0) {
                                        scope.innerForm.slushbox.$setValidity("required", false);
                                    } else {
                                        scope.innerForm.slushbox.$setValidity("required", true);
                                    }
                                }

                                // Set titles for the options
                                scope.timeouts.push($timeout(function () {

                                    // potential source of memory leak?
                                    var domOptions = document.getElementById(scope.name + "_available").options;
                                    for (var i = 0; i < domOptions.length; i++) {
                                        var label = domOptions[i].text;
                                        domOptions[i].setAttribute('title', label);
                                    }
                                }, 0));
                            }
                        });

                        ngModel.$render = function () {
                            if (ngModel.$modelValue != null) {
                                if (angular.isString(ngModel.$modelValue)) {
                                    if (scope.optionsLoaded) {
                                        // convert array of id's to array of objects with id and name
                                        var newModel = [];
                                        if (scope.dirOptions != null && angular.isArray(scope.dirOptions)) {
                                            ngModel.$modelValue.split(',').forEach(function (item, index) {
                                                scope.dirOptions.forEach(function(element){
                                                    if(element.id.toString().toLowerCase() == item.toLowerCase()) {
                                                        newModel.push(element);
                                                    }
                                                })                                            
                                            });
                                        }
                                        scope.ngModel = newModel;
                                    }
                                    else {
                                        needToChangeToString = true;
                                    }
                                }

                                if (angular.isArray(ngModel.$modelValue)) {
                                    if (scope.showValue == null) {
                                        scope.setShowValue();
                                    }
                                    
                                    if (scope.sortable) {
                                        ngModel.$modelValue.forEach(function (item, index) {
                                            item.sort_order = index + 1;
                                        });
                                    }
                                }
                            }
                        }

                        scope.ngChange = function () {
                            scope.submitted = false;
                            scope.processingChange = true;
                            scope.setShowValue();
                            scope.timeouts.push($timeout(function () {
                                if (scope.isRequired) {
                                    if (ngModel.$modelValue == null || ngModel.$modelValue.length == 0) {
                                        scope.innerForm.slushbox.$setValidity("required", false);
                                    }
                                    else {
                                        scope.innerForm.slushbox.$setValidity("required", true);
                                    }
                                }
                                if (scope.onChange != null) {
                                    scope.onChange();
                                }
                                if (scope.question !== undefined && scope.question.answer !== undefined) {
                                    scope.question.answer.invalid = !isEmpty(scope.innerForm.slushbox.$error);
                                }
                                scope.processingChange = false;
                            }, 0));
                        }

                        scope.filterFn = function (record) {
                            var filter = true;

                            if (ngModel.$modelValue != null && angular.isArray(ngModel.$modelValue)) {
                                ngModel.$modelValue.forEach(function (opt) {
                                    if (opt != null && record[scope.arrayValue] == opt[scope.compareValue]) {
                                        filter = false;
                                    }
                                });
                            }

                            return filter;
                        }

                        scope.submitted = false;
                        scope.$on('form:submit', function () {
                            scope.validate();
                            scope.submitted = true;
                        });

                        scope.$on('$destroy', function () {
                            scope.timeouts.forEach(function (timer) {
                                $timeout.cancel(timer);
                            });
                        });
                    }
                }
            }
        };
    }])
;